export const ME_UPDATE = 'ME_UPDATE'
export const ME_REPLACE = 'ME_REPLACE'

export const replaceMe = me => ({ type: ME_REPLACE, me })

export const updateMe = me => ({ type: ME_UPDATE, me })

export const fetchMe = () => (
  (dispatch, getState, api) => api({
    apiPath: 'users/me'
  })
)

export const refetchMe = () => (
  async (dispatch) => {
    const me = await dispatch(fetchMe())
    dispatch(replaceMe(me))
  }
)

export const logIn = (email, password, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'login',
      data: { email, password },
      cancelToken
    })
    await dispatch(refetchMe())
  }
)

export const requestPasswordReset = (email, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'post',
    apiPath: 'reset-password',
    data: { email },
    cancelToken
  })
)

export const signUp = (data, cancelToken) => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'signup',
      data,
      cancelToken
    })
    await dispatch(refetchMe())
  }
)

export const logOut = cancelToken => (
  async (dispatch, getState, api) => {
    await api({
      method: 'post',
      apiPath: 'logout',
      cancelToken,
    })
    dispatch(replaceMe(null))
  }
)

export const patchMe = (data, cancelToken) => (
  async (dispatch, getState, api) => {
    const nextMe = await api({
      method: 'patch',
      apiPath: 'users/me',
      data,
      cancelToken
    })
    dispatch(updateMe(nextMe))
  }
)

export const patchMeLazy = (data, cancelToken) => (
  async (dispatch, getState, api) => {
    const { me: prevMe } = getState()
    const nextMe = {
      ...prevMe,
      ...data,
      business: { ...prevMe.business, ...data.business }
    }
    dispatch(updateMe(nextMe))
    await api({
      method: 'patch',
      apiPath: 'users/me',
      data,
      cancelToken
    })
  }
)

export const requestEmailVerification = (email, cancelToken) => (
  (dispatch, getState, api) => api({
    method: 'post',
    apiPath: 'email-verification',
    data: { email },
    cancelToken
  })
)

export const patchMeManagerLazy = (data, cancelToken) => (
  async (dispatch, getState, api) => {
    const { me: prevMe } = getState()
    const nextMe = {
      ...prevMe,
      manager: {
        ...prevMe.manager,
        ...data
      }
    }
    dispatch(updateMe(nextMe))
    await api({
      method: 'patch',
      apiPath: 'managers/me',
      data,
      cancelToken
    })
  }
)
